import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { SelectOption } from '../types';

interface SingleDropdownProps {
  label: string;
  selectedValue: string;
  inputOptions: SelectOption[];
  deleteButton: JSX.Element;
  handleSelectedOption: (event: SelectChangeEvent) => void;
  renderValidationErrors: () => boolean | JSX.Element;
}

export default (props: SingleDropdownProps) => {
  const {
    label,
    selectedValue,
    inputOptions,
    deleteButton,
    handleSelectedOption,
    renderValidationErrors
  } = props;

  return (
    <>
      <InputLabel>{label}</InputLabel>
      <Select
        value={selectedValue}
        label={label}
        onChange={handleSelectedOption}
        endAdornment={deleteButton}
        sx={{
          cursor: 'pointer',
          '& .MuiSelect-iconOutlined': { display: selectedValue ? 'none' : '' },
          '&.Mui-focused .MuiIconButton-root': { color: 'primary.main' }
        }}
      >
        {inputOptions.map((option) => {
          return (
            <MenuItem key={option.id} value={option.value}>
              {option.value}
            </MenuItem>
          );
        })}
      </Select>
      {renderValidationErrors()}
    </>
  );
};
